import {Helmet} from 'react-helmet';
import Contact from "../../Page/contact";



const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Do you provide website design services in Kalyan-Dombivli?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we offer complete website design, development, SEO, and eCommerce services for businesses in Kalyan-Dombivli."
      }
    },
    {
      "@type": "Question",
      "name": "What is the cost of building a website in Kalyan-Dombivli?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The cost starts from ₹10,000 for a basic website. Advanced or custom features may increase the pricing based on your needs."
      }
    },
    {
      "@type": "Question",
      "name": "Will my website be mobile-friendly?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all our websites are responsive and optimized to work perfectly on mobile devices, tablets, and desktops."
      }
    },
    {
      "@type": "Question",
      "name": "Is SEO included in your website packages?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we include on-page SEO like meta titles, descriptions, schema markup, and fast loading features to help you rank better."
      }
    },
    {
      "@type": "Question",
      "name": "Can I update my website content myself?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we use CMS platforms like WordPress that allow you to easily update content, images, and blog posts without coding."
      }
    },
    {
      "@type": "Question",
      "name": "Do you develop eCommerce websites in Kalyan-Dombivli?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we create secure and scalable eCommerce websites using WooCommerce, Shopify, or custom platforms with payment integration."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to design a website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A basic site takes 5–7 days. More advanced websites with custom features or eCommerce functionalities may take 2–4 weeks."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer domain and hosting support?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we help you choose and register your domain, set up hosting, install SSL certificates, and configure business emails."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer website maintenance services?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we provide maintenance plans that cover regular updates, security checks, backups, and content changes."
      }
    },
    {
      "@type": "Question",
      "name": "How do I start a web design project with you in Kalyan-Dombivli?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can contact us through our website or phone. We’ll discuss your requirements and begin work on your project promptly."
      }
    }
  ]
}

function App1() {
  return (
   <>
 <Helmet>
  <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Pankaj | Website Designer In Kalyan-Dombivali</title>
<meta name="description" content="Top website designer in Kalyan-Dombivali. Get a modern website design with me in low cost. Elevate your online presence today!"/>
<meta name="keywords" content="website designer in kalyan, web designer in kalyan, web design company in kalyan, website design in kalyan, senior website developer, web development company in Kalyan-Dombivali, website maker in Kalyan-Dombivali, website design company, pankaj web designer, pankj, freelance website designer, website designer in Kalyan-Dombivali, website developer near me"/>
<meta property="og:title" content="Pankaj | Website Designer In Kalyan-Dombivali" />
<meta property="og:description" content="Top Website Designer In Kalyan-Dombivali. Get a modern website design with me in low cost. Elevate your online presence today!" />
<meta property="og:site_name" content="Pankaj | Website Designer In Kalyan-Dombivali" />
<meta property="og:url" content="https://www.pankj.com/website-designer-in-kalyan-dombivali"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Pankaj | Website Designer In Kalyan-Dombivali" />
<meta name="twitter:description" content="Top website designer in Kalyan-Dombivali. Get a modern website design with me in low cost. Elevate your online presence today!" />
<link rel="canonical" href="https://www.pankj.com/website-designer-in-kalyan-dombivali" />
        </Helmet>
 <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/bg.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
  <h1 className="multiple_effects fzsml" id="text3d">Website Designer in Kalyan-Dombivali</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/pks2.webp" alt="Website Designer" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   

    <main id="main">
  <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Website Designer in Kalyan-Dombivali</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
Are you in search of a creative and professional website designer in Kalyan-Dombivali? You’ve come to the right place! I’m Pankaj, a dedicated website designer committed to crafting visually stunning and highly functional websites that help you enhance your online presence and achieve your business goals.
<h3>Why Choose Pankaj for Your Website Design?</h3>
<ol>
  <li><strong>Custom Designs That Reflect Your Unique Brand</strong>
With years of experience in the website design industry, I specialize in creating custom solutions that embody your brand’s identity. Whether you require a sleek corporate website, an engaging e-commerce platform, or a personal blog, I ensure that your site is tailored to meet your specific needs.</li>
  <li><strong>SEO-Optimized Websites for Better Discoverability</strong>
A beautiful website is only effective if it can be found. I implement essential SEO practices in all my designs, helping your website rank higher on search engines like Google. This means increased visibility and more potential customers for your business.</li>
  <li><strong>Comprehensive Website Design Services</strong>
I offer a wide range of services, including website development, redesigns, and e-commerce solutions. My expertise with popular CMS platforms such as WordPress allows you to manage your content easily and effectively once your site is live.</li>
  <li><strong>Transparent Pricing and Ongoing Support</strong>
I believe in clear communication and transparent pricing. After discussing your project requirements, I provide a detailed quote, so there are no surprises. My commitment to client satisfaction means I am here to support you even after your website goes live.</li>
</ol>
<h3>Services Offered</h3>
<ul>
  <li><strong>Custom Website Design &amp; Redesign</strong>
Unique, modern designs tailored to your brand identity, enhancing user engagement and providing a seamless user experience.</li>
  <li><strong>E-commerce Website Development</strong>
Secure and user-friendly e-commerce platforms designed to maximize conversions and provide a smooth shopping experience for your customers.</li>
  <li><strong>Corporate and Personal Websites</strong>
Professionally designed websites that effectively showcase your business or personal projects, engaging visitors and clearly communicating your goals.</li>
  <li><strong>SEO and Digital Marketing Services</strong>
Basic SEO practices are included in all designs, with options for advanced strategies through collaboration with trusted marketing partners.</li>
</ul>
<h3>Get Started Today</h3>
Ready to elevate your online presence? Contact me today to discuss your vision, and let’s work together to create a website that truly represents your brand in the digital landscape.
<h2>Frequently Asked Questions</h2>

<h4>What types of websites can Pankaj design in Kalyan-Dombivali?</h4>
<p>Pankaj specializes in designing a variety of websites, including corporate sites, e-commerce platforms, personal blogs, and portfolios. Each website is customized to meet the specific needs and goals of the client.</p>

<h4>Why should I choose Pankaj as my website designer?</h4>
<p>Pankaj offers high-quality, responsive, and SEO-friendly websites crafted with meticulous attention to detail. His extensive experience ensures that each project effectively communicates your brand identity while providing a seamless user experience.</p>

<h4>Does Pankaj provide SEO services for my website?</h4>
<p>Yes, Pankaj incorporates basic SEO practices in all his website designs to enhance visibility on search engines. For more advanced SEO strategies, he can collaborate with trusted partners who specialize in digital marketing.</p>

<h4>How much does it cost to design a website with Pankaj?</h4>
<p>The cost of designing a website varies based on several factors, including the project's complexity, the number of pages, and any additional features you may want. Pankaj provides project-specific quotes after discussing your requirements and budget.</p>

<h4>Can I update my website content after it’s launched?</h4>
<p>Absolutely! Pankaj builds websites using user-friendly CMS platforms like WordPress, allowing you to easily manage and update your content once the site is live. He also provides training and documentation to assist you in making updates.</p>

<h4>What if I need help with my website after it’s live?</h4>
<p>Pankaj offers ongoing maintenance and support for all his clients. This includes troubleshooting, updates, and performance improvements to ensure your website remains secure and effective over time.</p>

<h4>How long does it take to complete a website design project?</h4>
<p>The timeline for completing a website design project varies based on its complexity and specific requirements. After discussing your project, Pankaj will provide a realistic timeline, which typically ranges from a few weeks to a couple of months.</p>

<h4>How can I get in touch with Pankaj for my website design project?</h4>
<p>You can reach out to Pankaj through the contact form on this website or by using the provided contact information. He will be happy to discuss your project and help you create a website that meets your needs.</p>


          </div>
        </div>
      </div>

    </section>
 <Contact />
    </main>
    </>
  );
}
export default App1;
